module.exports = __webpack_public_path__ + "img/yan7.e8d758a4.png";